export default __webpack_public_path__ + "static/media/wordIcon.9228e1ff.svg";